module.exports = __webpack_public_path__ + "img/close.028ac733.svg";